import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withNamespaces } from 'react-i18next';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';

import * as locators from './locators';
import CustomTabs from '../../../components/molecules/Tabs';
import Grid from '../../../components/molecules/Grid';
import Title from '../../../components/atoms/Title';
import Typography from '../../../components/atoms/Typography';
import Container from '../../../components/molecules/Container';
import TabContent from './TabContent';
import useStyles from './style';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import { getComponentName, getPageName } from '../../../utils/getPageComponentInfo';
const CompanyLocations = props => {
  const locateUsText = props && props.t && props.t('locateUs');
  const pageName = getPageName(props);
  const componentName = getComponentName(props);
  const continents = get(props, 'fields.continents', []);
  const title = get(props, 'fields.title', '');
  const classes = useStyles();
  const renderTabs = () => {
    const tabElementList =
      continents.length > 0 &&
      continents.map((tabItem, index) => {
        const { fields } = tabItem;

        return {
          data: TabContent({ ...fields, index, pageName, componentName }),
          label: get(tabItem, 'fields.tabName.value', ''),
        };
      });
    return <CustomTabs tabs={tabElementList} className='pills-tabs-container' />;
  };
  return (
    <Container data-locator={locators.COMPONENT_NAME} className={classes.root}>
      <Grid>
        {locateUsText && <Title text={{ value: locateUsText }} />}
        {title && title.value && (
          <Typography component="h2" variant="h4" className={classes.officeHeading}>
            <Text field={title} />
          </Typography>
        )}
        {renderTabs()}
      </Grid>
    </Container>
  );
};

export default withErrorBoundary(
  withSitecoreContext()(withNamespaces()(CompanyLocations))
);
